import { request } from '../request';
import { saveTicketSettings } from './sagas';

export default {
  getEnterpriseData: () =>
    request({
      url: '/virtual-operator/customer',
      method: 'GET',
    }),
  saveEnterpriseMessage: (params) =>
    request({
      url: `/virtual-operator/welcome`,
      method: 'POST',
      data: params,
    }),
  saveEnterpriseFestivities: (params) =>
    request({
      url: `/virtual-operator/festivities`,
      method: 'POST',
      data: params,
    }),
  saveEnterpriseInfo: (params) =>
    request({
      url: `/virtual-operator/info`,
      method: 'POST',
      data: params,
    }),
  saveOpening: (params) =>
    request({
      url: `/virtual-operator/opening`,
      method: 'POST',
      data: params,
    }),
  getUsers: (params) =>
    request({
      url: '/virtual-operator/users',
      method: 'GET',
      params,
    }),
  saveUser: (params) =>
    request({
      url: `/virtual-operator/users/${params.id}`,
      method: 'POST',
      data: params.data,
    }),
  getOffices: (params) =>
    request({
      url: '/virtual-operator/offices',
      method: 'GET',
      params,
    }),
  insertOffice: (params) =>
    request({
      url: `/virtual-operator/offices`,
      method: 'POST',
      data: params.data,
    }),
  editOffice: (params) =>
    request({
      url: `/virtual-operator/offices/${params.id}`,
      method: 'POST',
      data: params.data,
    }),
  getMessages: (params) =>
    request({
      url: '/virtual-operator/messages',
      method: 'GET',
      params,
    }),
  insertMessage: (params) =>
    request({
      url: `/virtual-operator/messages`,
      method: 'POST',
      data: params.data,
    }),
  editMessage: (params) =>
    request({
      url: `/virtual-operator/messages/${params.id}`,
      method: 'POST',
      data: params.data,
    }),
  deleteMessage: (id) =>
    request({
      url: `/virtual-operator/messages/${id}`,
      method: 'DELETE',
    }),
  getSettings: () =>
    request({
      url: '/virtual-operator/settings',
      method: 'GET',
    }),
  saveFestivitySettings: (params) =>
    request({
      url: `/virtual-operator/settings/festivities`,
      method: 'POST',
      data: params,
    }),
  saveClosingSettings: (params) =>
    request({
      url: `/virtual-operator/settings/closing`,
      method: 'POST',
      data: params,
    }),
  getStatistics: (params) =>
    request({
      url: '/virtual-operator/statistics',
      method: 'GET',
      params,
    }),
  getChatDetails: (params) =>
    request({
      url: `/virtual-operator/details`,
      method: 'GET',
      params,
    }),
  getMonitoring: (params) =>
    request({
      url: `/virtual-operator/monitoring`,
      method: 'GET',
      params,
    }),
  getCosts: (params) =>
    request({
      url: `/virtual-operator/costs`,
      method: 'GET',
      params,
    }),
  getAmbrogioCosts: (params) =>
    request({
      url: `/virtual-operator/ambrogio-costs`,
      method: 'GET',
      params,
    }),
  getAmbrogioPbxs: () =>
    request({
      url: `/virtual-operator/pbxs`,
      method: 'GET',
    }),
  saveNoCreditRule: (rule) =>
    request({
      url: `/virtual-operator/settings/nocredit-rule`,
      method: 'POST',
      data: { rule },
    }),
  saveTicketSettings: (params) =>
    request({
      url: `/virtual-operator/settings/ticket-settings`,
      method: 'POST',
      data: params,
    }),
};
